<!--
 * @Author: w9013327 v-maijiahua@oppo.com
 * @Date: 2023-06-14 14:45:39
 * @LastEditors: W9013327 v-maijiahua@oppo.com
 * @LastEditTime: 2024-03-05 10:14:28
 * @FilePath: \community-backendf:\community-frontend\src\views\post\web\components\userList.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
  <el-scrollbar height="200px" always>
    <template v-if="keyword">
      <van-list
        v-model:loading="loading" 
        @load="searchUser"
        :finished="finished"
        :error-text="$t('error')"
        :loading-text="$t('loading')"
        :finished-text="$t('finished')"
        :immediate-check="false"
      > 
          <p
            class="user-item"
            v-for="user in userList"
            :key="user.uid"
            v-html="user.nickname"
            @click="onSelect(user)"
          >
          </p>
        
      </van-list> 
    </template>
  </el-scrollbar>
</template>

<script setup>
import { ref, watch } from 'vue'
import { $throttle } from '@/utils/lodashFuncs'
import http from '@/service'
import Xss from '@/utils/xssFilter'

const props = defineProps(['keyword'])

const emit = defineEmits(['insertMentionGuy'])

const keyword = ref('')
const loading = ref(false)
const finished = ref(false)
const page = ref(1)
const userList = ref([])

const searchUser = $throttle(async () => {
  const { code, data, msg } = await http.getUserList({
    keyword: keyword.value,
    limit: 20,
    page: page.value
  })
  loading.value = false
  if (code === 200 && data && data.rows.length) {
    finished.value = page.value * 20 >= data.total
    let highlightChangeList = ['content', 'nickname', 'subject', 'name', 'introduce', 'title']
    data.rows.forEach(i => {
      let highLightList = i.nickname.match(/<highLight.*?<\/highLight>/gi) || []
      i.nickname = Xss(i.nickname, {
        highLight: [],
      }, null)
      highLightList.forEach(s => {
        const tag = document.createElement("div");
        tag.innerHTML = s;
        i.nickname = i.nickname.replace(s, `<span style="color: var(--theme);">${tag.innerText}</span>`);
      })
    })
    userList.value = [ ...userList.value, ...data.rows ]
    page.value ++
  } else {
    userList.value = []
    finished.value = true
  }
}, 1000, { leading: false, trailing: true })

const onSelect = (user) => {
  emit('insertMentionGuy', user)
}

watch(() => props.keyword, (val) => {
  keyword.value = val
  userList.value = []
  if (!val) {
    keyword.value = ''
    loading.value = false
    finished.value = false
  } else {
    page.value = 1
    searchUser()
  }
}, {
  immediate: true,
  deep: true
})

</script>

<style lang="postcss" scoped>
.user-item {
  padding: 12px 24px;
  font-size: 16px;
  cursor: pointer;
  &:hover {
    background-color: var(--background-listpressed);
  }
}
</style>